export { default } from './trash-2'
